exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#eventBrowserModal .v--modal-box.v--modal{min-width:410px;min-height:180px}#eventBrowserModal .v-text-field__slot input,#eventBrowserModal .v-text-field__slot label{font-size:12px}#eventBrowserModal .modal__footer{display:none}#eventBrowserModal :not(.v-icon){font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-743803e4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/eventBrowser/EventBrowser.vue
// module id = 1937
// module chunks = 0